import { ISO8601DateString } from "@/types";
import { format, formatDistance, parseISO } from "date-fns";

export function formatDate(date: number): string {
  return date > 0 ? format(new Date().setTime(date), "M/d/yyyy") : "";
}

export function formatDateFromISO(date: ISO8601DateString): string {
  if (!date) return "";
  if (date === "") return "";
  return format(parseISO(date), "M/d/yyyy");
}

export function formatDateTimeFromISO(date: ISO8601DateString): string {
  if (!date) return "";
  if (date === "") return "";
  return format(parseISO(date), "M/d/yyyy h:mm a");
}

export function formatPrice(price: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(price);
}

export function dateToISO8601(date: Date): ISO8601DateString {
  return format(date, "yyyy-MM-dd") as ISO8601DateString;
}

export function formatAgo(date: Date): string {
  return formatDistance(date, new Date(), { addSuffix: true });
}

export function formatAgoFromISO(date: ISO8601DateString): string {
  return formatAgo(parseISO(date));
}
